import { IDetailRowProps, IVitalDataSetting, TVitalDataSearchItem } from '../../types/life-id';
import moment from 'moment';
import { getDateFormat } from '../utils-helpers';
import getGraphData from './get-graph-data';
import getBadgeProps from './get-badge-props';

export function getDetailRowProps(
  settings: IVitalDataSetting[],
  selector: keyof TVitalDataSearchItem,
  oneSided: boolean = false,
) {
  return (itemFromSearchApi: TVitalDataSearchItem): IDetailRowProps => {
    const value = itemFromSearchApi[selector] as string | number;

    return {
      ...getBadgeProps(itemFromSearchApi.source),
      time: moment(itemFromSearchApi.datetime).format(getDateFormat()),
      createdTime: moment(itemFromSearchApi.datetime).format('HH:mm'),
      value,
      chartProps: {
        oneSidedRange: oneSided,
        ...getGraphData(settings, [value], oneSided, 'line'),
      },
    };
  };
}
